import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Image,
  Input,
  InputNumber,
  notification,
  Row,
  Select,
  Tabs,
  Typography,
  Upload,
} from "antd";
import React, { Fragment, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

import { PlusOutlined, UserOutlined } from "@ant-design/icons";

import TextArea from "antd/es/input/TextArea";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { loadAllDesignation } from "../../redux/rtk/features/designation/designationSlice";
import { loadAllEmploymentStatus } from "../../redux/rtk/features/employemntStatus/employmentStatusSlice";
import {
  fetchValidityEntry,
  getDefaultValidity,
  getLeavePoliciesWithLimit,
  loadAllLeavePolicy,
} from "../../redux/rtk/features/leavePolicy/leavePolicySlice";
import { getAllCountry } from "../../redux/rtk/features/masters/countrySlice";
import { getAllDocumentType } from "../../redux/rtk/features/masters/documentTypeSlice";
import { getAllGender } from "../../redux/rtk/features/masters/genderSlice";
import { getAllSalutation } from "../../redux/rtk/features/masters/salutationSlice";

import axios from "axios";
import { getAllIssueCountry } from "../../redux/rtk/features/masters/issueCountrySlice";
import { getAllNoticePeriod } from "../../redux/rtk/features/masters/noticePeriodSlice";
import { getAllPaymentType } from "../../redux/rtk/features/masters/paymentTypeSlice";
import { getAllRelationShip } from "../../redux/rtk/features/masters/relationShipSlice";
import { getAllState } from "../../redux/rtk/features/masters/stateSlice";
import { getAllWorkPlace } from "../../redux/rtk/features/masters/workPlaceSlice";
import { loadAllSalaryComponents } from "../../redux/rtk/features/salaryComponent/salaryComponentSlice";
import { loadAllShift } from "../../redux/rtk/features/shift/shiftSlice";
import {
  addStaff,
  getCompanyOfficeMaster,
  loadAllStaff,
} from "../../redux/rtk/features/user/userSlice";
import { loadAllWeeklyHoliday } from "../../redux/rtk/features/weeklyHoliday/weeklyHolidaySlice";
import { getDepartments } from "../department/departmentApis";
import { getRoles } from "../role/roleApis";
import EmployeeEducationForm from "./EmployeeEducationForm";
import getSetting from "../../api/getSettings";
import dayjs from "dayjs";

const { TabPane } = Tabs;
const { Option } = Select;
const { Dragger } = Upload;
const { Title } = Typography;

const AddUser = () => {
  const [loader, setLoader] = useState(false);
  const [currentTab, setCurrentTab] = useState("1");
  const [enabledTabs, setEnabledTabs] = useState(["1"]);

  const dispatch = useDispatch();
  const { Title } = Typography;
  const { Option } = Select;
  const [list, setList] = useState(null);
  const [department, setDepartment] = useState(null);
  const [ctc, setCtc] = useState(0);
  const [inHandSalary, setInHandSalary] = useState(0);
  const [salaryData, setSalaryData] = useState({ ctc: 0, inHandSalary: 0 });
  const [salary, setSalary] = useState(0);
  const users = useSelector((state) => state.users?.list);
  const [imagePreview, setImagePreview] = useState(null);
  const [boxSize, setBoxSize] = useState({ width: 100, height: 100 }); // Initial size
  console.log("users", users);
  const [isTabValid, setIsTabValid] = useState([
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [sortCodeValue, setSortCodeValue] = useState("");
  const [isAddressSame, setIsAddressSame] = useState(false);

  const [education, setEducation] = useState([
    {
      degree: "",
      institution: "",
      fieldOfStudy: "",
      result: "",
      startDate: "",
      endDate: "",
    },
  ]);
  const [thumbFileList, setThumbFileList] = useState([]);
  const [isMarried, setIsMarried] = useState(false);

  // useseletor to get designations from redux
  const designation = useSelector((state) => state.designations?.list);
  const workPlace = useSelector((state) => state.workPlace?.list);

  // const officeName = useSelector((state) => state.users?.officeName);
  const employmentStatus = useSelector((state) => state.employmentStatus?.list);
  const shift = useSelector((state) => state.shift?.list);
  const weeklyHoliday = useSelector((state) => state.weeklyHoliday?.list);
  // const leavePolicy = useSelector((state) => state.leavePolicy?.list);
  const leavePolicyLimit = useSelector(
    (state) => state.leavePolicy?.leavePolicyLimit
  );
  const { validity, defaultValidity, loading: validityLoading } = useSelector(
    (state) => state.leavePolicy
  );
  const [selectedValidityId, setSelectedValidityId] = useState(null);

  const salaryComponentData = useSelector(
    (state) => state.salaryComponents?.list
  );
  const gender = useSelector((state) => state.gender?.list);
  const salutation = useSelector((state) => state.salutation?.list);
  const relationShip = useSelector((state) => state.relationShip?.list);
  const paymentType = useSelector((state) => state.paymentType?.list);
  const documentType = useSelector((state) => state.documentType?.list);
  const issueCountry = useSelector((state) => state.issueCountry?.list);
  const state = useSelector((state) => state.state?.list);
  const country = useSelector((state) => state.country?.list);
  const noticePeriod = useSelector((state) => state.noticePeriod?.list);

  const [joinDate, setJoinDate] = useState({ date: null });
  const [probationPeriod, setProbationPeriod] = useState({ date: null });
  const [salaryStartDate, setSalaryStartDate] = useState({ date: null });
  const [designationStartDate, setDesignationStartDate] = useState({
    date: null,
  });
  const [workPlaceStartDate, setWorkPlaceStartDate] = useState({ date: null });

  const dateJoinFormatted = joinDate.date ? joinDate.date : null;
  const dateProbationPeriod = probationPeriod.date
    ? probationPeriod.date
    : null;

  const dateSalaryFormatted = salaryStartDate.date
    ? salaryStartDate.date
    : null;
  const dateDesignationFormatted = designationStartDate.date
    ? designationStartDate.date
    : null;
  const dateWorkPlaceFormatted = workPlaceStartDate.date
    ? workPlaceStartDate.date
    : null;

  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [officeName, setOfficeName] = useState([]);
  const [companyNames, setCompanyNames] = useState([]);
  const [passportNumber, setPassportNumber] = useState("");
  const [licenseNumber, setLicenseNumber] = useState("");
  const [visaNumber, setVisaNumber] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  useEffect(() => {
    dispatch(loadAllStaff({ status: true }));
  }, []);

  useEffect(() => {
    getRoles()
      .then((d) => setList(d))
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    getDepartments()
      .then((d) => setDepartment(d))
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    const fetchCompanyNames = async () => {
      try {
        const response = await getSetting();
        console.log("API Response:", response);

        if (response && Array.isArray(response.result)) {
          setCompanyNames(response.result);
        } else {
          console.error("API response is not an array:", response);
          setCompanyNames([]);
        }
      } catch (error) {
        console.error("Error fetching company names:", error);
        setCompanyNames([]);
      }
    };

    fetchCompanyNames();
  }, []);

  useEffect(() => {
    dispatch(loadAllDesignation());
    dispatch(loadAllEmploymentStatus());
    dispatch(loadAllShift());
    dispatch(loadAllWeeklyHoliday());
    dispatch(loadAllLeavePolicy());
    dispatch(loadAllSalaryComponents());
    dispatch(getCompanyOfficeMaster());
    dispatch(getAllGender());
    dispatch(getAllRelationShip());
    dispatch(getAllPaymentType());
    dispatch(getAllDocumentType());
    dispatch(getAllIssueCountry());
    dispatch(getAllState());
    dispatch(getAllCountry());
    dispatch(getAllSalutation());
    dispatch(getAllWorkPlace());
    dispatch(getAllNoticePeriod());
    dispatch(getLeavePoliciesWithLimit());
    dispatch(fetchValidityEntry());
    dispatch(getDefaultValidity());
  }, []);

  useEffect(() => {
    if (defaultValidity?.length > 0) {
      setSelectedValidityId(defaultValidity[0]?.validity_id);
    }
  }, [defaultValidity]);

  const filteredLeavePolicies = useMemo(() => {
    if (!leavePolicyLimit) return [];
    return leavePolicyLimit.filter((policy) =>
      selectedValidityId ? policy.validity_id === selectedValidityId : true
    );
  }, [leavePolicyLimit, selectedValidityId]);

  const handleValidityChange = (validityId) => {
    setSelectedValidityId(validityId);
  };

  const [form] = Form.useForm();

  // const validateUniqueUserName = (_, value) => {
  // 	if (users.some(user => user.userName === value)) {
  // 		return Promise.reject(new Error('This username is already taken.'));
  // 	}
  // 	return Promise.resolve();
  // };

  // const validateUniqueEmail = (_, value) => {
  // 	if (users.some(user => user.email === value)) {
  // 		return Promise.reject(new Error('This email is already in use.'));
  // 	}
  // 	return Promise.resolve();
  // };

  const calculateTotals = () => {
    const salaryComponents = {};

    // Iterate over salary component data and fetch values from the form
    salaryComponentData.forEach((component) => {
      const componentName = component.componentName;
      let fieldValue = form.getFieldValue(`salaryComponents.${componentName}`);

      // Check if the calculation type is '% of Basic'
      if (component.calculationType === "% of Basic") {
        const basicSalary = form.getFieldValue("salaryComponents.Basic");
        fieldValue = ((fieldValue || 0) * (basicSalary || 0)) / 100; // Calculate the percentage of Basic
      }

      salaryComponents[componentName] = fieldValue || 0;

      const amountFieldName = `${componentName}Amount`;
      form.setFieldsValue({
        [`salaryComponents.${amountFieldName}`]: fieldValue || 0,
      });
    });

    const incomeComponents = salaryComponentData
      ?.filter((component) => component.componentType === "Income")
      .map((component) => salaryComponents[component.componentName] || 0);

    const deductionComponents = salaryComponentData
      ?.filter((component) => component.componentType === "Deduction")
      .map((component) => salaryComponents[component.componentName] || 0);

    const totalIncome = incomeComponents.reduce((acc, curr) => acc + curr, 0);
    const totalDeductions = deductionComponents.reduce(
      (acc, curr) => acc + curr,
      0
    );

    setSalaryData({
      ctc: totalIncome,
      inHandSalary: totalIncome - totalDeductions,
    });

    setSalary(salaryData.inHandSalary);

    // Update form fields with new salaryData values
    form.setFieldsValue({
      ctc: totalIncome,
      inHandSalary: totalIncome - totalDeductions,
    });
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview({
          url: reader.result,
          name: file.name,
        });
      };
      reader.readAsDataURL(file);
    }
    setSelectedImage(file);
  };

  const handleFileUpload = (info, fieldKey) => {
    console.log("lala", info);
    console.log("land", fieldKey);
    const fileList = [...info.fileList].slice(-1);
    form.setFields([
      {
        name: ["documents", fieldKey, "file"],
        value: fileList,
      },
    ]);
    setThumbFileList(info.fileList);
    if (info.fileList.length > 0) {
      setSelectedDocument(info.fileList[0].originFileObj);
    }
  };

  const onFinish = async (values) => {
    const salaryComponents = {};
    salaryComponentData.forEach((component) => {
      const componentId = component.id;
      const componentName = component.componentName;
      let fieldValue = form.getFieldValue(`salaryComponents.${componentName}`);
      salaryComponents[componentId] = fieldValue;
    });

    const leavePolicyData = {};
    leavePolicyLimit.forEach((policy) => {
      let fieldValue = form.getFieldValue(`policy.${policy.id}`);
      leavePolicyData[policy.id] = fieldValue;
    });
    console.log("LP", leavePolicyData);

    const FormData = {
      ...values,
      passportExpiryDate: values.passportExpiryDate
        ? values.passportExpiryDate.format("YYYY-MM-DD")
        : null,
      DLExpiryDate: values.DLExpiryDate
        ? values.DLExpiryDate.format("YYYY-MM-DD")
        : null,
      visaExpiryDate: values.visaExpiryDate
        ? values.visaExpiryDate.format("YYYY-MM-DD")
        : null,
      joinDate: values.joinDate ? values.joinDate.format("YYYY-MM-DD") : null,
      probationPeriod: values.probationPeriod
        ? values.probationPeriod.format("YYYY-MM-DD")
        : null,
      salaryStartDate: values.salaryStartDate
        ? values.salaryStartDate.format("YYYY-MM-DD")
        : null,
      designationStartDate: values.designationStartDate
        ? values.designationStartDate.format("YYYY-MM-DD")
        : null,
      workPlaceStartDate: values.workPlaceStartDate
        ? values.workPlaceStartDate.format("YYYY-MM-DD")
        : null,
      // dateJoinFormatted,
      // dateProbationPeriod,
      // dateSalaryFormatted,
      dateDesignationFormatted,
      // dateWorkPlaceFormatted,
      salaryComponents,
      educations: values.educations || education,
      salary: salary || 0,
      file: thumbFileList[0]?.originFileObj,
      leavePolicyData,
    };

    console.log("FormData", FormData);
    setLoader(true);

    try {
      values.phone = `+44${values.phone}`;
      const resp = await dispatch(addStaff(FormData));
      setLoader(true);

      if (resp.payload.message === "success") {
        // form.resetFields();
        setLoader(false);
      } else if (resp.payload.message === "error") {
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.log(error.message);
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoader(false);
    console.log("Failed:", errorInfo);
    // message.error("Please fill out all required fields!");
    notification.error({
      message: "Submission Error",
      description:
        "Please ensure all required fields are filled out before submitting.",
    });
  };

  const handleNext = async () => {
    try {
      let fieldsToValidate = [];
      switch (currentTab) {
        case "1":
          fieldsToValidate = [
            "salutationId",
            "firstName",
            "lastName",
            "userName",
            "password",
            "birthAnniversary",
            "marriageAnniversary",
            "gender",
            "bloodGroup",
            "maritalStatus",
          ];
          break;
        case "2":
          fieldsToValidate = [
            "phone",
            "alternateNumber",
            "emergencyContactNumber",
            "contactPersonName",
            "contactPersonRelation",
          ];
          break;
        case "3":
          fieldsToValidate = [
            "street",
            "city",
            "state",
            "zipCode",
            "country",
            "pAddress",
            "pCity",
            "pState",
            "pZipCode",
            "pCountry",
          ];
          break;
        case "4":
          fieldsToValidate = [
            "joinDate",
            "employeeId",
            "employmentStatusId",
            "esic",
            "reportingManagerId",
            "departmentId",
            "roleId",
            "shiftId",
            "leavePolicyId",
            "weeklyHolidayId",
            "email",
            "officialMailId",
            "pfEligiblity",
            "uan",
            "paymentType",
            "CompanyOfficeId",
            "probationPeriod",
          ];
          break;
        case "5":
          fieldsToValidate = ["designationId", "StartDate"];
          break;
        case "6":
          fieldsToValidate = [
            "startDate",
            ...salaryComponentData.map(
              (comp) => `salaryComponents.${comp.componentName}`
            ),
          ];
          break;
        case "7":
          fieldsToValidate = [
            "accountHolderName",
            "bankName",
            "accountNumber",
            "shortCode",
            "branchName",
          ];
          break;
        case "8":
          fieldsToValidate = [
            "NINumber",
            "passportNumber",
            "passportExpiryDate",
            "licenseNumber",
            "DLIssueCountry",
            "visaNumber",
            "taxCode",
            "issueCountry",
            "licenseClass",
            "DLExpiryDate",
            "visaExpiryDate",
          ];
          break;
        // Add other cases as needed
        default:
          break;
      }

      // Validate fields
      await form.validateFields(fieldsToValidate);

      // Determine next tab
      const nextTab = String(Number(currentTab) + 1);
      if (!enabledTabs.includes(nextTab)) {
        setEnabledTabs([...enabledTabs, nextTab]);
      }

      setCurrentTab(nextTab);
    } catch (errorInfo) {
      console.log("Validation Failed:", errorInfo);
    }
  };

  const handlePrevious = () => {
    const prevTab = String(Number(currentTab) - 1);
    setCurrentTab(prevTab);
  };

  const isTabDisabled = (tabKey) => {
    return !enabledTabs.includes(tabKey);
  };

  const formatSortCode = (val) => {
    // Remove any non-digit characters
    const digits = val.replace(/\D/g, "");

    // Take only first 6 digits
    const truncated = digits.slice(0, 6);

    // Add hyphens after every 2 digits
    const parts = truncated.match(/.{1,2}/g) || [];
    return parts.join("-");
  };

  // const handleChangeSort = (e) => {
  // 	const formatted = formatSortCode(e.target.value);
  // 	setSortCodeValue(formatted);
  //   };

  const handleChangeSort = (e) => {
    // Get the raw input value and remove any non-digits
    const inputValue = e.target.value.replace(/\D/g, "");

    // Take only the first 6 digits
    const truncated = inputValue.slice(0, 6);

    // Add hyphens after every 2 digits
    let formatted = "";
    for (let i = 0; i < truncated.length; i++) {
      if (i > 0 && i % 2 === 0) {
        formatted += "-";
      }
      formatted += truncated[i];
    }

    setSortCodeValue(formatted);
  };

  const handleKeyDown = (e) => {
    // Allow only: digits, backspace, delete, tab, arrow keys
    const allowedKeys = [
      "Backspace",
      "Delete",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
    ];
    if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"]; // blood groups
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  return (
    <Fragment bordered={false}>
      <UserPrivateComponent permission={"create-user"}>
        <div className="mr-top mt-5 p-5 ant-card " style={{ maxWidth: "100%" }}>
          <Form
            size="small"
            form={form}
            name="basic"
            labelCol={{
              span: 10,
            }}
            wrapperCol={{
              span: 22,
            }}
            initialValues={{
              remember: true,
              salaryComponents: {},
              ...(leavePolicyLimit || []).reduce((acc, policy) => {
                acc[`policy.${policy.id}`] = ""; // Set initial value for each policy field
                return acc;
              }, {}),
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            onValuesChange={calculateTotals}
          >
            <Tabs activeKey={currentTab} onChange={setCurrentTab}>
              <TabPane
                tab="User Information"
                key="1"
                disabled={isTabDisabled("1")}
              >
                <Col span={24} className="gutter-row form-color">
                  {/* <h2 className='text-center text-xl mt-3 mb-3 txt-color'>User Information</h2> */}
                  <Form.Item style={{ marginBottom: "10px" }} required={false}>
                    <Upload
                      style={{ width: "50px", height: "20px" }}
                      listType="picture-circle"
                      beforeUpload={() => false}
                      name="file"
                      fileList={thumbFileList}
                      onChange={handleFileUpload}
                      onPreview={handlePreview}
                      maxCount={1}
                    >
                      <p>
                        <UserOutlined />
                      </p>
                      {/* <p className="ant-upload-hint">
												User Image
												</p> */}
                    </Upload>
                    {previewImage && (
                      <Image
                        wrapperStyle={{
                          display: "none",
                        }}
                        preview={{
                          visible: previewOpen,
                          onVisibleChange: (visible) => setPreviewOpen(visible),
                          afterOpenChange: (visible) =>
                            !visible && setPreviewImage(""),
                        }}
                        src={previewImage}
                      />
                    )}
                  </Form.Item>

                  <Row gutter={[16, 16]}>
                    {/* First Column */}
                    {/* <Col span={4}>
										<Form.Item
											style={{ marginBottom: "10px" }}
											required={false}
										>
											<Dragger
												listType='picture-card'
												beforeUpload={() => false}
												name='file'
												fileList={thumbFileList}
												onChange={handleFileUpload}
												maxCount={1}
											>
												<p className="ant-upload-drag-icon">
													<InboxOutlined />
												</p>
												<p className="ant-upload-hint">
												Upload an image
												</p>
											</Dragger>
										</Form.Item> */}
                    {/* </Col> */}
                    <Col span={12}>
                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Title"
                        name="salutationId"
                        rules={[
                          {
                            required: true,
                            message: "Please select your Title!",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Title"
                          showSearch
                          allowClear
                          mode="combobox"
                        >
                          {salutation &&
                            salutation.map((salutation) => (
                              <Option key={salutation.id} value={salutation.id}>
                                {salutation.salutations}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="First Name"
                        name="firstName"
                        rules={[
                          {
                            required: true,
                            message: "Please input First Name!",
                          },
                        ]}
                      >
                        <Input placeholder="First Name" />
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="User Name"
                        name="userName"
                        rules={[
                          {
                            required: true,
                            message: "Please input User Name!",
                          },
                          // { validator: validateUniqueUserName },
                        ]}
                      >
                        <Input placeholder="User Name" />
                      </Form.Item>

                      {/* <Form.Item
												style={{ marginBottom: "10px" }}
												label="Father's Name"
												name='fatherName'
												rules={[
													{ required: true, message: "Please input Father's Name!" },
												]}
											>
												<Input placeholder="Father's Name" />
											</Form.Item> */}

                      {/* <Form.Item
												style={{ marginBottom: "10px" }}
												label='Birthdate'
												name='birthdate'
												rules={[
													{ required: true, message: "Please input Birthdate!" },
												]}
											>
												<DatePicker
													format='YYYY-MM-DD'
													placeholder='Select Birthdate'
													style={{ width: '100%' }}
												/>
											</Form.Item> */}

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Gender"
                        name="gender"
                        // rules={[
                        // 	{ required: true, message: "Please select your gender!" },
                        // ]}
                      >
                        <Select
                          placeholder="Select Gender"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            String(option.children)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {gender &&
                            gender.map((gender) => (
                              <Option key={gender.id} value={gender.id}>
                                {gender.gender}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Blood Group"
                        name="bloodGroup"
                        // rules={[
                        // 	{ required: true, message: "Please Select Blood Group!" },
                        // ]}
                      >
                        <Select
                          placeholder="Select Blood Group"
                          showSearch
                          allowClear
                          mode="combobox"
                          size="middle"
                          style={{ width: "100%" }}
                        >
                          {bloodGroups.map((bloodGroup) => (
                            <Select.Option key={bloodGroup} value={bloodGroup}>
                              {bloodGroup}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    {/* Second Column */}
                    <Col span={12}>
                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Last Name"
                        name="lastName"
                        rules={[
                          {
                            required: true,
                            message: "Please input Last Name!",
                          },
                        ]}
                      >
                        <Input placeholder="Last Name" />
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Password"
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "Please input your password!",
                          },
                        ]}
                      >
                        <Input placeholder="Password" />
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="D.O.B"
                        name="birthAnniversary"
                        rules={[
                          {
                            required: false,
                            message: "Please input Birth Anniversary!",
                          },
                        ]}
                      >
                        <DatePicker
                          format="YYYY-MM-DD"
                          placeholder="Select Birth Anniversary"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Marital Status"
                        name="maritalStatus"
                      >
                        <Select
                          placeholder="Select Marital Status"
                          showSearch
                          allowClear
                          mode="combobox"
                          onChange={(value) => {
                            // Update state based on selected value
                            setIsMarried(value === "married");

                            // Prepare value for submission (null, 1, or 0)
                            const maritalStatus = value
                              ? value === "married"
                                ? 1
                                : 0
                              : null;

                            console.log(
                              "Marital Status to Save:",
                              maritalStatus
                            );

                            // Update form field value if needed (optional)
                            // form.setFieldsValue({ maritalStatus });
                          }}
                        >
                          <Select.Option value="single">Single</Select.Option>
                          <Select.Option value="married">Married</Select.Option>
                        </Select>
                      </Form.Item>

                      {/* <Form.Item
												style={{ marginBottom: "10px" }}
												label='Aadhar Card Number'
												name='aadhar'
												rules={[
													{ required: true, message: "Please input Aadhar Card Number!" },
												]}
											>
												<Input placeholder='Aadhar Card Number' />
											</Form.Item> */}
                    </Col>
                  </Row>
                </Col>
              </TabPane>

              <TabPane tab="Contact Details" key="2">
                {/* <TabPane tab="Contact Details" key="2" disabled={isTabDisabled("2")}> */}

                <Col span={12} className="gutter-row">
                  <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                    Contact Details
                  </h2>
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Email"
                    name="email"
                    rules={[
                      { required: false, message: "Please input email!" },
                      { type: "email", message: "Please enter a valid email!" },
                      // { validator: validateUniqueEmail },
                    ]}
                  >
                    <Input placeholder="Email" />
                  </Form.Item>
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Phone"
                    name="phone"
                    rules={[
                      {
                        required: true,
                        message: "Please input phone number!",
                      },
                      // {
                      // 	pattern: /^[0-9]{10}$/,
                      // 	message: "Please enter a valid 10-digit phone number!",
                      // },
                    ]}
                  >
                    <Input
                      placeholder="Phone"
                      maxLength={10}
                      addonBefore="+44"
                    />
                  </Form.Item>
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Alternate Number"
                    name="alternateNumber"
                    rules={[
                      // {
                      // 	required: true,
                      // 	message: "Please input Emergency Contact Number !",
                      // },
                      {
                        pattern: /^[0-9]{10}$/,
                        message:
                          "Please enter a valid 10-digit Emergency Contact Number!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Phone"
                      maxLength={10}
                      addonBefore="+44"
                    />
                  </Form.Item>
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Emergency Contact Number"
                    name="emergencyContactNumber"
                    rules={[
                      // {
                      // 	required: true,
                      // 	message: "Please input Emergency Contact Number !",
                      // },
                      {
                        pattern: /^[0-9]{10}$/,
                        message:
                          "Please enter a valid 10-digit Emergency Contact Number!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Phone"
                      maxLength={10}
                      addonBefore="+44"
                    />
                  </Form.Item>
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Emergency Contact Person"
                    name="contactPersonName"
                    // rules={[
                    // 	// {
                    // 	// 	required: true,
                    // 	// 	message: "Please input Emergency Contact Number !",
                    // 	// },

                    // ]}
                  >
                    <Input placeholder="Contact Person Name" />
                  </Form.Item>
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Contact Person Relation"
                    name="contactPersonRelation"
                    // rules={[
                    // 	{
                    // 		required: true,
                    // 		message: "Please select or input a relation!",
                    // 	},
                    // ]}
                  >
                    <Select
                      placeholder="Select or type relation"
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        String(option.children)
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {relationShip &&
                        relationShip.map((relationShip) => (
                          <Option key={relationShip.id} value={relationShip.id}>
                            {relationShip.relationship}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </TabPane>

              {/* <TabPane tab="Address Information" key="3"  disabled={isTabDisabled("3")}> */}
              <TabPane tab="Address Information" key="3">
                <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                  Address Information
                </h2>

                <Row gutter={24}>
                  <Col span={12}>
                    <Card
                      title="Current Address"
                      bordered={true}
                      style={{ height: "100%" }}
                    >
                      <Form.Item
                        label="House Address"
                        name="street"
                        rules={[
                          {
                            required: true,
                            message: "Please input house address!",
                          },
                        ]}
                      >
                        <Input placeholder="Enter Address" />
                      </Form.Item>

                      {/* <Form.Item
												label='City'
												name='city'
												rules={[{ required: true, message: "Please input city!" }]}
											>
												<Input placeholder='City' />
											</Form.Item> */}
                      <Form.Item
                        label="City"
                        name="city"
                        // rules={[{ required: true, message: "Please select a city!" }]}
                      >
                        <Input placeholder="City"></Input>
                      </Form.Item>
                      {/* <Form.Item
												label='City'
												name='state'
												rules={[{ required: true, message: "Please select a city!" }]}
											>
												<Select placeholder="Select a city"

													showSearch allowClear
													filterOption={(input, option) =>
														String(option.children).toLowerCase().includes(input.toLowerCase())
													}>
													{state &&
														state.map((state) => (
															<Option key={state.id} value={state.id}>
																{state.stateName}
															</Option>
														))}
												</Select>
											</Form.Item> */}

                      <Form.Item
                        label="Post Code"
                        name="zipCode"
                        rules={[
                          {
                            required: true,
                            message: "Please input Post Code!",
                          },
                          // { pattern: /^[0-9]{6}$/, message: "Please enter a valid 6-digit Post Code!" },
                        ]}
                      >
                        <Input placeholder="000000" />
                      </Form.Item>

                      {/* <Form.Item
												label='Country'
												name='country'
												rules={[{ required: true, message: "Please select a country!" }]}
											>
												<Select placeholder="Select a country"
													showSearch allowClear
													filterOption={(input, option) =>
														String(option.children).toLowerCase().includes(input.toLowerCase())
													}>
													{country &&
														country.map((country) => (
															<Option key={country.id} value={country.id}>
																{country.countryName}
															</Option>
														))}
												</Select>
											</Form.Item> */}
                      <Form.Item
                        label="Country"
                        name="country"
                        // rules={[{ required: true, message: "Please select a city!" }]}
                      >
                        <Input placeholder="Country"></Input>
                      </Form.Item>
                    </Card>
                  </Col>

                  <Col span={12}>
                    <Card
                      title="Permanent Address"
                      bordered={true}
                      style={{ height: "100%" }}
                    >
                      <Form.Item
                        label="House Address"
                        name="pAddress"
                        rules={[
                          {
                            required: true,
                            message: "Please input house address!",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Address"
                          readOnly={isAddressSame}
                        />
                      </Form.Item>

                      <Form.Item
                        label="City"
                        name="pCity"
                        // rules={[{ required: true, message: "Please input city!" }]}
                      >
                        <Input placeholder="City" readOnly={isAddressSame} />
                      </Form.Item>

                      {/* <Form.Item
												label='City'
												name='pState'
												rules={[{ required: true, message: "Please select a city!" }]}
											>
												<Select placeholder="Select a city" readOnly={isAddressSame}
													showSearch allowClear
													filterOption={(input, option) =>
														String(option.children).toLowerCase().includes(input.toLowerCase())
													}>
													{state &&
														state.map((state) => (
															<Option key={state.id} value={state.id}>
																{state.stateName}
															</Option>
														))}
												</Select>
											</Form.Item> */}

                      <Form.Item
                        label="Post Code"
                        name="pZipCode"
                        rules={[
                          {
                            required: true,
                            message: "Please input Post Code!",
                          },
                          // { pattern: /^[0-9]{6}$/, message: "Please enter a valid 6-digit Post Code!" },
                        ]}
                      >
                        <Input placeholder="000000" readOnly={isAddressSame} />
                      </Form.Item>

                      {/* <Form.Item
												label='Country'
												name='pCountry'
												rules={[{ required: true, message: "Please select a country!" }]}
											>
												<Select placeholder="Select a country"
													showSearch allowClear
													filterOption={(input, option) =>
														String(option.children).toLowerCase().includes(input.toLowerCase())
													}
														>
													{country &&
														country.map((country) => (
															<Option key={country.id} value={country.id}>
																{country.countryName}
															</Option>
														))}
												</Select>
											</Form.Item> */}
                      <Form.Item
                        label="Country"
                        name="pCountry"
                        // rules={[{ required: true, message: "Please input Country!" }]}
                      >
                        <Input placeholder="Country" readOnly={isAddressSame} />
                      </Form.Item>
                    </Card>
                  </Col>
                </Row>

                <Row style={{ marginTop: "20px" }}>
                  <Col>
                    <Form.Item>
                      <Checkbox
                        onChange={(e) => {
                          setIsAddressSame(e.target.checked);
                          if (e.target.checked) {
                            form.setFieldsValue({
                              pAddress: form.getFieldValue("street"),
                              pCity: form.getFieldValue("city"),
                              pZipCode: form.getFieldValue("zipCode"),
                              pCountry: form.getFieldValue("country"),
                            });
                          } else {
                            form.setFieldsValue({
                              pAddress: "",
                              pCity: "",
                              pZipCode: "",
                              pCountry: "",
                            });
                          }
                        }}
                      >
                        Current address and permanent address are the same
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </TabPane>

              {/* <TabPane tab="Employee Information" key="4"  disabled={isTabDisabled("4")}> */}
              <TabPane tab="Employee Information" key="4">
                <Col span={24} className="gutter-row form-color">
                  <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                    Employee Information
                  </h2>

                  <Row gutter={[16, 16]}>
                    {/* First Column */}
                    <Col span={12}>
                      <Form.Item
                        rules={[
                          {
                            required: true,
                            message: "Please select a company!",
                          },
                        ]}
                        label="Company"
                        name="CompanyOfficeId"
                        style={{ marginBottom: "10px" }}
                      >
                        <Select
                          style={{ width: "100%" }}
                          placeholder="Please select company"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            option?.children
                              ?.toLowerCase()
                              ?.includes(input.toLowerCase())
                          }
                        >
                          {(companyNames || []).map((company) => (
                            <Option key={company.id} value={company.id}>
                              {company.company_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Joining Date"
                        name="joinDate"
                        rules={[
                          {
                            required: true,
                            message: "Please input joining date!",
                          },
                        ]}
                      >
                        <DatePicker
                          className="date-picker hr-staffs-date-picker"
                          onChange={(date) => {
                            if (date) {
                              const joinDate = date.startOf("day"); // Sets the time to 00:00:00
                              setJoinDate(joinDate);
                            } else {
                              setJoinDate(null); // Handle case where date is cleared
                            }
                            // setJoinDate(date);
                            form.validateFields([
                              "probationPeriod",
                              "startDate",
                              "StartDate",
                              "startDate",
                            ]);
                          }}
                          format="YYYY-MM-DD"
                          inputReadOnly
                        />
                      </Form.Item>

                      {/* TODO: Add an Upload Section for Image */}

                      <Form.Item
                        name={"employmentStatusId"}
                        style={{ marginBottom: "10px" }}
                        rules={[
                          {
                            required: true,
                            message: "Please Select Employment Status!",
                          },
                        ]}
                        label="Employee Status"
                      >
                        <Select
                          placeholder="Select Status"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            String(option.children)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {employmentStatus &&
                            employmentStatus
                              .slice() // Creates a shallow copy to avoid mutating the original array
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((employmentStatus) => (
                                <Option
                                  key={employmentStatus.id}
                                  value={employmentStatus.id}
                                >
                                  {employmentStatus.name}
                                </Option>
                              ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name={"departmentId"}
                        style={{ marginBottom: "10px" }}
                        label="Department"
                        rules={[
                          {
                            required: true,
                            message: "Please Select Department!",
                          },
                        ]}
                      >
                        <Select
                          loading={!department}
                          placeholder="Select Department"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            String(option.children)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {department &&
                            department
                              .slice() // Creates a shallow copy to avoid mutating the original array
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((department) => (
                                <Option
                                  key={department.id}
                                  value={department.id}
                                >
                                  {department.name}
                                </Option>
                              ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        rules={[
                          {
                            required: true,
                            message: "Please Select User Role!",
                          },
                        ]}
                        label="Role"
                        name={"roleId"}
                        style={{ marginBottom: "10px" }}
                      >
                        <Select
                          loading={!list}
                          style={{
                            width: "100%",
                          }}
                          placeholder="Please select"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            String(option.children)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {list &&
                            list
                              .slice() // Creates a shallow copy to avoid mutating the original array
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((role) => (
                                <Option key={role.id} value={role.id}>
                                  {role.name}
                                </Option>
                              ))}
                        </Select>
                      </Form.Item>
                      {/* <Form.Item
												rules={[
													{ required: true, message: "Please Select Leave Policy!" },
												]}
												label='Leave Policy'
												name={"leavePolicyId"}
												style={{ marginBottom: "10px" }}>
												<Select
													loading={!leavePolicy}
													size='middle'
													showSearch allowClear mode="combobox"


													style={{
														width: "100%",
													}}
													placeholder='Please select'>
													{leavePolicy &&
														leavePolicy.map((leavePolicy) => (
															<Option key={leavePolicy.id} value={leavePolicy.id}>
																{leavePolicy.name}
															</Option>
														))}
												</Select>
											</Form.Item> */}

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Pension"
                        name="pfEligiblity"
                        rules={[
                          {
                            required: true,
                            message: "Please select Pension!",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Pension"
                          showSearch
                          allowClear
                          mode="combobox"
                        >
                          <Select.Option value="yes">Opt in</Select.Option>
                          <Select.Option value="no">Opt out</Select.Option>
                        </Select>
                      </Form.Item>

                      {/* Payment Type Field */}
                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Payment Type"
                        name="paymentType"
                        rules={[
                          {
                            required: true,
                            message: "Please select Payment Type!",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Payment Type"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            String(option.children)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {paymentType &&
                            paymentType
                              .slice() // Creates a shallow copy to avoid mutating the original array
                              .sort((a, b) =>
                                a.paymentType.localeCompare(b.paymentType)
                              )
                              .map((paymentType) => (
                                <Option
                                  key={paymentType.id}
                                  value={paymentType.id}
                                >
                                  {paymentType.paymentType}
                                </Option>
                              ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name={"noticePeriodId"}
                        style={{ marginBottom: "10px" }}
                        label="Notice Period"
                        // rules={[
                        // 	{ required: true, message: "Please Select Department!" },
                        // ]}
                      >
                        <Select
                          loading={!noticePeriod}
                          placeholder="Select Notice Period"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            String(option.children)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {noticePeriod &&
                            noticePeriod.map((noticePeriod) => (
                              <Option
                                key={noticePeriod.id}
                                value={noticePeriod.id}
                              >
                                {noticePeriod.noticePeriod}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>

                      {/* <Form.Item
												name="CompanyOfficeId"
												style={{ marginBottom: "10px" }}
												label="Office"
											// rules={[
											// 	{ required: true, message: "Please select an office!" },
											// ]}
											>
												<Select
													loading={!officeName}
													placeholder="Select Office"
													showSearch allowClear
										filterOption={(input, option) =>
											String(option.children).toLowerCase().includes(input.toLowerCase())
										}>
													{officeName &&
														officeName.map((office) => (
															<Option key={office.OfficeId} value={office.OfficeId}>
																{office.OfficeName}
															</Option>
														))}
												</Select>
											</Form.Item> */}
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Employee ID"
                        name="employeeId"
                        rules={[
                          {
                            required: true,
                            message: "Please input Employee ID!",
                          },
                        ]}
                      >
                        <Input placeholder="Emp-001" />
                      </Form.Item>
                      {/* <Form.Item
												style={{ marginBottom: "10px" }}
												label='ESIC'
												name='esic'
												rules={[
													{ required: true, message: "Please input ESIC!" },

												]}
											>
												<Input placeholder='ESIC' />
											</Form.Item> */}

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Reporting Manager"
                        name="reportingManagerId"
                        rules={[
                          {
                            required: false,
                            message: "Please select a user!",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Reporting Manager"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            String(option.children)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {users &&
                            users
                              .filter((user) => user.firstName && user.lastName) // Ensure both firstName and lastName are defined
                              .slice() // Create a shallow copy
                              .sort((a, b) =>
                                `${a.firstName} ${a.lastName}`.localeCompare(
                                  `${b.firstName} ${b.lastName}`
                                )
                              ) // Sort by full name
                              .map((user) => (
                                <Select.Option key={user.id} value={user.id}>
                                  {user.firstName} {user.lastName}
                                </Select.Option>
                              ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        rules={[
                          {
                            required: false,
                            message: "Please Select User Shift !",
                          },
                        ]}
                        label="Shift"
                        name={"shiftId"}
                        style={{ marginBottom: "10px" }}
                      >
                        <Select
                          loading={!shift}
                          style={{
                            width: "100%",
                          }}
                          placeholder="Please select"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            String(option.children)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {shift &&
                            shift.map((shift) => (
                              <Option key={shift.id} value={shift.id}>
                                {shift.name}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        rules={[
                          {
                            required: false,
                            message: "Please Select Weekly Off!",
                          },
                        ]}
                        label="Weekly Off"
                        showSearch
                        allowClear
                        mode="combobox"
                        name={"weeklyHolidayId"}
                        style={{ marginBottom: "10px" }}
                      >
                        <Select
                          loading={!weeklyHoliday}
                          style={{
                            width: "100%",
                          }}
                          placeholder="Please select"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            String(option.children)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {weeklyHoliday &&
                            weeklyHoliday.map((weeklyHoliday) => (
                              <Option
                                key={weeklyHoliday.id}
                                value={weeklyHoliday.id}
                              >
                                {weeklyHoliday.name}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Official Email"
                        name="officialMailId"
                        rules={[
                          {
                            required: false,
                            message: "Please input Official email!",
                          },
                          {
                            type: "email",
                            message: "Please enter a valid Official email!",
                          },
                          // { validator: validateUniqueEmail },
                        ]}
                      >
                        <Input placeholder="Email" />
                      </Form.Item>

                      {/* <Form.Item
												style={{ marginBottom: "10px" }}
												label='NI NO'
												name='uan'
												rules={[
													{ required: true, message: "Please input NI NO!" },
													{ pattern: /^[0-9]{12}$/, message: "Please enter a valid 12-digit NI NO!" }
												]}
											>
												<Input placeholder='Enter NI NO' maxLength={12} />
											</Form.Item> */}

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Probation Period End"
                        name="probationPeriod"
                        rules={[
                          {
                            required: false,
                            message: "Please input Probation Period date!",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const joinDate = getFieldValue("joinDate");
                              if (!value || !joinDate) {
                                return Promise.resolve();
                              }
                              if (value.unix() >= joinDate.unix()) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error(
                                  "Probation period end date must be after or equal to the joining date!"
                                )
                              );
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          className="date-picker hr-staffs-date-picker"
                          onChange={(date) => {
                            setProbationPeriod({ date });
                          }}
                          format="YYYY-MM-DD"
                          inputReadOnly
                        />
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Medical Information"
                        name="medicalInfo"
                      >
                        <TextArea placeholder="Medical Information" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </TabPane>
              {/* <TabPane tab="Designation Information" key="5"  disabled={isTabDisabled("5")}> */}
              <TabPane tab="Work Place" key="5">
                <Col span={12} className="gutter-row">
                  <Form.Item
                    rules={[
                      { required: true, message: "Please Select Work Place!" },
                    ]}
                    label="Work Place"
                    name={"workPlaceId"}
                    style={{ marginBottom: "10px" }}
                  >
                    <Select
                      loading={!shift}
                      style={{
                        width: "100%",
                      }}
                      placeholder="Please select Work Place"
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        String(option.children)
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {workPlace &&
                        workPlace
                          .slice() // Creates a shallow copy to avoid mutating the original array
                          .sort((a, b) =>
                            a.workplace.localeCompare(b.workplace)
                          )
                          .map((workPlace) => (
                            <Option key={workPlace.id} value={workPlace.id}>
                              {workPlace.workplace}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>

                  {/* <Form.Item
										rules={[{ required: true, message: "Please select Work Place!" }]}
										label="Work Place"
										name="workPlaceId"
										style={{ marginBottom: "10px" }}
									>
										<Select
											loading={loader}
											placeholder="Please select Work Place"
											allowClear
											showSearch
											filterOption={(input, option) =>
												String(option.children).toLowerCase().includes(input.toLowerCase())
											}
										>
											{companyNames.map((company) => (
												<Option key={company} value={company}>
													{company}
												</Option>
											))}
										</Select>
									</Form.Item> */}

                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Start Date"
                    name="startDate"
                    rules={[
                      {
                        required: true,
                        message: "Please input start date!",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const joinDate = getFieldValue("joinDate");
                          if (!value || !joinDate) {
                            return Promise.resolve();
                          }
                          if (value.unix() >= joinDate.unix()) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              "Start date must be after or equal to the joining date!"
                            )
                          );
                        },
                      }),
                    ]}
                  >
                    <DatePicker
                      className="date-picker hr-staffs-date-picker"
                      onChange={(date) => {
                        setWorkPlaceStartDate({ date });
                        form.validateFields(["joinDate"]);
                      }}
                      format="YYYY-MM-DD"
                      inputReadOnly
                    />
                  </Form.Item>
                </Col>
              </TabPane>

              {/* <TabPane tab="Designation Information" key="5"  disabled={isTabDisabled("5")}> */}
              <TabPane tab="Designation Information" key="6">
                <Col span={12} className="gutter-row">
                  <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                    Designation Information
                  </h2>

                  <Form.Item
                    rules={[
                      { required: true, message: "Please Select Designation!" },
                    ]}
                    label="Designation"
                    name={"designationId"}
                    style={{ marginBottom: "10px" }}
                  >
                    <Select
                      loading={!shift}
                      style={{
                        width: "100%",
                      }}
                      placeholder="Please select Designation"
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        String(option.children)
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {designation &&
                        designation
                          .slice() // Creates a shallow copy to avoid mutating the original array
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((designation) => (
                            <Option key={designation.id} value={designation.id}>
                              {designation.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Start Date"
                    name="StartDate"
                    rules={[
                      {
                        required: true,
                        message: "Please input start date!",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const joinDate = getFieldValue("joinDate");
                          if (!value || !joinDate) {
                            return Promise.resolve();
                          }
                          if (value.unix() >= joinDate.unix()) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              "Start date must be after or equal to the joining date!"
                            )
                          );
                        },
                      }),
                    ]}
                  >
                    <DatePicker
                      className="date-picker hr-staffs-date-picker"
                      onChange={(date, dateString) =>
                        setDesignationStartDate({ date: dateString })
                      }
                      format="YYYY-MM-DD"
                      inputReadOnly
                    />
                  </Form.Item>

                  {/* <Form.Item
										style={{ marginBottom: "10px" }}
										label='End Date'
										name='EndDate'>
										<DatePicker className='date-picker hr-staffs-date-picker' />
									</Form.Item> */}
                </Col>
              </TabPane>

              {/* <TabPane tab="Salary Information" key="6"  disabled={isTabDisabled("6")}> */}
              {/* <TabPane tab="Salary Information" key="7" >

								<h2 className='text-center text-xl mt-3 mb-3 txt-color'>
									Salary Information
								</h2>
								<br />
								<Col span={12} className='gutter-row'>
									<Form.Item
										label='Salary Start Date'
										name='startDate'
										style={{ marginBottom: "10px" }}
										rules={[
											{
												required: true,
												message: "Please input Probation Period date!"
											},
											({ getFieldValue }) => ({
												validator(_, value) {
													const joinDate = getFieldValue('joinDate');
													if (!value || !joinDate) {
														return Promise.resolve();
													}
													if (value.unix() >= joinDate.unix()) {
														return Promise.resolve();
													}
													return Promise.reject(
														new Error("Probation period end date must be after or equal to the joining date!")
													);
												},
											}),
										]}
									>
										<DatePicker className='date-picker hr-staffs-date-picker'
											onChange={(date, dateString) => {
												setSalaryStartDate({ date: dateString });
												form.validateFields(['joinDate']);
											}}
											format="YYYY-MM-DD"
											inputReadOnly
										/>
									</Form.Item>
								</Col>
								<hr />
								<br />

								<Row gutter={24}>
									<Col span={12}>
										<h3 className='text-center text-xl mt-3 mb-3 txt-color'>
											Income
										</h3>
										{salaryComponentData
											?.filter(component => component.componentType === 'Income')
											.map((component, index) => (
												<Form.Item
													key={index}
													style={{ marginBottom: '10px' }}
													label={component.componentName}
													name={`salaryComponents.${component.componentName}`}
													
												// rules={[
												// 	{
												// 		required: true,
												// 		message: `Please input ${component.componentName}!`,
												// 	},
												// ]}
												>
													<InputNumber
														min={0}
														step={0.01}
														style={{ width: '100%' }}
														placeholder={component.componentName}
														addonAfter={component.calculationType === '% of Basic' ? '% of Basic' : null}
													/>
												</Form.Item>
											))}

										<br />


									</Col>
									<Col span={12}>
										<h3 className='text-center text-xl mt-3 mb-3 txt-color'>
											Deduction
										</h3>
										{salaryComponentData
											?.filter(component => component.componentType === 'Deduction')
											.map((component, index) => (
												<Form.Item
													key={index}
													style={{ marginBottom: '10px' }}
													label={component.componentName}
													name={`salaryComponents.${component.componentName}`}
												// rules={[
												// 	{
												// 		required: true,
												// 		message: `Please input ${component.componentName}!`,
												// 	},
												// ]}
												>
													<InputNumber
														min={0}
														step={0.01}
														style={{ width: '100%' }}
														placeholder={component.componentName}
														addonAfter={component.calculationType === '% of Basic' ? '% of Basic' : null}
													/>
												</Form.Item>
											))}

										<br />


									</Col>
								</Row>

								<hr />
								<br />
								<Row gutter={24}>
									<Col span={12}>
										{salaryComponentData
											?.filter(component => component.componentType === 'Income')
											.map((component, index) => {
												if (component.calculationType === '% of Basic') {
													return (
														<Form.Item
															key={index} // To provide a unique key for each mapped element
															style={{ marginBottom: '10px' }}
															label={`${component.componentName} Amount`}
															name={`salaryComponents.${component.componentName}Amount`}
															initialValue={0} // Initial value set to 0
														// rules={[
														// 	{
														// 		required: true,
														// 		message: `Please input ${component.componentName} Amount!`,
														// 	},
														// ]}
														>
															<InputNumber
																disabled // Disable input for calculated amounts
																style={{ width: '100%' }}
															/>
														</Form.Item>
													);
												} else {
													return null; // Return null for elements that don't match the condition
												}
											})
										}
									</Col>
									<Col span={12}>
										{salaryComponentData
											?.filter(component => component.componentType === 'Deduction')
											.map((component, index) => {
												if (component.calculationType === '% of Basic') {
													return (
														<Form.Item
															key={index}
															style={{ marginBottom: '10px' }}
															label={`${component.componentName} Amount`}
															name={`salaryComponents.${component.componentName}Amount`}
															initialValue={0}
														// rules={[
														// 	{
														// 		required: true,
														// 		message: `Please input ${component.componentName} Amount!`,
														// 	},
														// ]}
														>
															<InputNumber
																disabled
																style={{ width: '100%' }}
															/>
														</Form.Item>
													);
												} else {
													return null;
												}
											})
										}
									</Col>
								</Row>

								<hr />
								<br />
								<Row gutter={24}>
									<Col span={12}>
										<Form.Item
											label='CTC'
											name='ctc'
										>
											<InputNumber
												defaultValue={salaryData.ctc}
												readOnly
												style={{ width: '100%' }}
											/>
										</Form.Item>
									</Col>
									<Col span={12}>
										<Form.Item
											label='In Hand Salary'
											name='inHandSalary'
										>
											<InputNumber
												defaultValue={salaryData.inHandSalary}
												readOnly
												style={{ width: '100%' }}
											/>
										</Form.Item>
									</Col>
								</Row>

							</TabPane> */}

              <TabPane tab="Leave Policies" key="7">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl mt-3 mb-3 txt-color">
                    Leave Policy Information
                  </h2>
                  <Select
                    placeholder="Select Validity Policy"
                    value={selectedValidityId}
                    onChange={handleValidityChange}
                    style={{ width: "220px" }}
                    loading={validityLoading}
                  >
                    {validity && validity.length > 0 ? (
                      validity.map((validityItem) => (
                        <Option key={validityItem.id} value={validityItem.id}>
                          {validityItem.name}
                        </Option>
                      ))
                    ) : (
                      <Option disabled>No validity policies available</Option>
                    )}
                  </Select>
                </div>
                <Row gutter={24}>
                  {filteredLeavePolicies?.map((policy) => (
                    <Col span={7} key={policy.id} className="gutter-row">
                      <Form.Item
                        label={policy.name}
                        name={`policy.${policy.id}`}
                        style={{ marginBottom: "40px" }}
                      >
                        <InputNumber placeholder="Allowed Leaves" />
                      </Form.Item>
                    </Col>
                  ))}
                </Row>
                {filteredLeavePolicies?.length === 0 && (
                  <p className="text-center txt-color-secondary py-4">
                    No leave policies found for the selected validity period.
                  </p>
                )}
              </TabPane>

              <TabPane tab="Bank Details" key="8">
                <Col span={12} className="gutter-row form-color">
                  <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                    Bank Details
                  </h2>
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Account Holder Name"
                    name="accountHolderName"
                    rules={[
                      {
                        required: true,
                        message: "Please input Account Holder Name!",
                      },
                    ]}
                  >
                    <Input placeholder="Account Holder Name" />
                  </Form.Item>

                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Bank Name"
                    name="bankName"
                    rules={[
                      {
                        required: false,
                        message: "Please input Bank Name!",
                      },
                    ]}
                  >
                    <Input placeholder="Bank Name" />
                  </Form.Item>

                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Account Number"
                    name="accountNumber"
                    rules={[
                      {
                        required: true,
                        message: "Please input Account Number!",
                      },
                      {
                        // pattern: /^[0-9]{9,18}$/,
                        message:
                          "Please enter a valid account number (9-18 digits)!",
                      },
                    ]}
                  >
                    <Input placeholder="Account Number" maxLength={18} />
                  </Form.Item>

                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Sort Code"
                    name="shortCode"
                    rules={[
                      {
                        required: true,
                        message: "Please input Short Code!",
                      },
                      {
                        // pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                        pattern: /^[0-9]{6}$/,
                        message: "Please enter a valid Short code!",
                      },
                    ]}
                  >
                    <Input placeholder="Short Code" maxLength={6} />
                  </Form.Item>

                  {/* <Form.Item
      style={{ marginBottom: "10px" }}
      label='Sort Code'
      name='sortCode'
      rules={[
        {
          required: true,
          message: "Please input Sort Code!",
        },
        {
          pattern: /^\d{2}-\d{2}-\d{2}$/,
          message: "Please enter a valid Sort Code in format XX-XX-XX!",
        },
      ]}
    >
      <Input 
        placeholder='XX-XX-XX'
        value={sortCodeValue}
        onChange={handleChangeSort}
		onKeyDown={handleKeyDown}
        maxLength={8} // 6 digits + 2 hyphens
		style={{ letterSpacing: '1px' }}
      />
    </Form.Item> */}

                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Branch Name"
                    name="branchName"
                  >
                    <Input placeholder="Branch Name" />
                  </Form.Item>
                </Col>
              </TabPane>

              <TabPane tab="Sensitive Details" key="9">
                <Col span={24} className="gutter-row form-color">
                  <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                    Sensitive Details
                  </h2>

                  <Row gutter={[16, 16]}>
                    {/* Left Column */}
                    <Col span={12}>
                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="NI Number"
                        name="NINumber"
                        // rules={[{ required: true, message: "Please input NI Number!" }]}
                      >
                        <Input placeholder="NI Number" />
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Passport Number"
                        name="passportNumber"
                        // rules={[{ required: true, message: "Please input Passport Number!" }]}
                      >
                        <Input
                          placeholder="Passport Number"
                          value={passportNumber}
                          onChange={(e) => setPassportNumber(e.target.value)}
                        />
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Passport Expiry Date"
                        name="passportExpiryDate"
                        rules={
                          passportNumber
                            ? [
                                {
                                  required: true,
                                  message: "Please input Passport Expiry Date!",
                                },
                              ]
                            : []
                        }
                      >
                        <DatePicker
                          className="date-picker"
                          format="YYYY-MM-DD"
                          placeholder="Select Expiry Date"
                          inputReadOnly
                        />
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Driving License Number"
                        name="licenseNumber"
                        // rules={[{ required: true, message: "Please input License Number!" }]}
                      >
                        <Input
                          placeholder="License Number"
                          value={licenseNumber}
                          onChange={(e) => setLicenseNumber(e.target.value)}
                        />
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Country of Issue (License)"
                        name="DLIssueCountry"
                        // rules={[{ required: true, message: "Please select Country of Issue for License!" }]}
                      >
                        <Select
                          placeholder="Select Country"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            String(option.children)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {issueCountry &&
                            issueCountry
                              .filter((d) => d.issueCountry) // Filter out items with undefined or null issueCountrys
                              .slice() // Creates a shallow copy to avoid mutating the original array
                              .sort((a, b) =>
                                a.issueCountry.localeCompare(b.issueCountry)
                              )
                              .map((issueCountry) => (
                                <Option
                                  key={issueCountry.id}
                                  value={issueCountry.id}
                                >
                                  {issueCountry.issueCountry}
                                </Option>
                              ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Visa Number"
                        name="visaNumber"
                        // rules={[{ required: true, message: "Please input Visa Number!" }]}
                      >
                        <Input
                          placeholder="Visa Number"
                          value={visaNumber}
                          onChange={(e) => setVisaNumber(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    {/* Right Column */}
                    <Col span={12}>
                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Tax Code"
                        name="taxCode"
                        // rules={[{ required: true, message: "Please input Tax Code!" }]}
                      >
                        <Input placeholder="Tax Code" />
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Country of Issue (Passport)"
                        name="issueCountry"
                        // rules={[{ required: true, message: "Please select Country of Issue!" }]}
                      >
                        <Select
                          placeholder="Select Country"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            String(option.children)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {issueCountry &&
                            issueCountry
                              .filter((d) => d.issueCountry) // Filter out items with undefined or null issueCountrys
                              .slice() // Creates a shallow copy to avoid mutating the original array
                              .sort((a, b) =>
                                a.issueCountry.localeCompare(b.issueCountry)
                              )
                              .map((issueCountry) => (
                                <Option
                                  key={issueCountry.id}
                                  value={issueCountry.id}
                                >
                                  {issueCountry.issueCountry}
                                </Option>
                              ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="License Class"
                        name="licenseClass"
                        // rules={[{ required: true, message: "Please input License Class!" }]}
                      >
                        <Input placeholder="License Class" />
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Driving License Expiry Date"
                        name="DLExpiryDate"
                        rules={
                          licenseNumber
                            ? [
                                {
                                  required: true,
                                  message: "Please input License Expiry Date!",
                                },
                              ]
                            : []
                        }
                        // rules={[{ required: true, message: "Please input License Expiry Date!" }]}
                      >
                        <DatePicker
                          className="date-picker"
                          format="YYYY-MM-DD"
                          placeholder="Select Expiry Date"
                          inputReadOnly
                        />
                      </Form.Item>

                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Visa Expiry Date"
                        name="visaExpiryDate"
                        // rules={[{ required: true, message: "Please input Visa Expiry Date!" }]}
                        rules={
                          visaNumber
                            ? [
                                {
                                  required: true,
                                  message: "Please input Visa Expiry Date!",
                                },
                              ]
                            : []
                        }
                      >
                        <DatePicker
                          className="date-picker"
                          format="YYYY-MM-DD"
                          placeholder="Select Expiry Date"
                          inputReadOnly
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </TabPane>

              <TabPane tab="Education Information" key="10">
                <h2 className="text-center text-xl mt-3 mb-5 txt-color">
                  Education Information
                </h2>
                <div className="text-center">
                  <p className="text-red-500 text-base mb-4">
                    Please add education information using the button below
                  </p>
                </div>
                <Form.List name="educations">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <EmployeeEducationForm
                          key={key}
                          name={name}
                          remove={remove}
                          restField={restField}
                        />
                      ))}
                      <Form.Item
                        style={{ marginBottom: "10px" }}
                        wrapperCol={{
                          offset: 4,
                          span: 16,
                        }}
                      >
                        <Button
                          type="dashed"
                          size="middle"
                          style={{ color: "#fff", backgroundColor: "#2c3e50" }}
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                        >
                          Add Education Information
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
                <br />
                <hr /> <hr /> <hr /> <hr />
                <br />
                <Form.Item
                  style={{ marginBottom: "10px", marginTop: "20px" }}
                  wrapperCol={{ offset: 4, span: 16 }}
                >
                  <Button
                    size="large"
                    onClick={() => setLoader(true)}
                    block
                    type="primary"
                    htmlType="submit"
                    shape="round"
                    loading={loader}
                  >
                    Add New Staff
                  </Button>
                </Form.Item>
              </TabPane>
            </Tabs>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button onClick={handlePrevious} disabled={currentTab === "1"}>
                Previous
              </Button>
              <Button onClick={handleNext} disabled={currentTab === "10"}>
                Next
              </Button>
            </div>
          </Form>
        </div>
      </UserPrivateComponent>
    </Fragment>
  );
};

export default AddUser;
